import { pageInfo, detailInfo, deleteBatch, exportData, carrierRejectImport, submitApproval, warehouseReceiptUpload, urgentRejectReport, downLoadTemplate, toBeReceivedExportData } from './../api';
import { getRejectReasonList, getRejectStatusList} from '../../../../api/selects'
const rejectInfo = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailInfoObj: null,
    deleteBatchObj: null,
    exportObj: null,
    carrierRejectImportObj: null,
    submitApprovalObj: null,
    warehouseReceiptUploadObj: null,
    rejectReportObj: null,
    templateObj: null,
    rejectReasonListObj: null,
    rejectStatusListObj: null,
    toBeReceivedExportObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true, true] }));
    },
    REJECT_REASON_LIST(state, data) {
      state.rejectReasonListObj = data;
    },
    REJECT_STATUS_LIST(state, data) {
      state.rejectStatusListObj = data;
    },
    DETAIL_INFO(state, data) {
      state.detailInfoObj = data.obj || {};
    },
    DELETE_BATCH(state, data) {
      state.deleteBatchObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    CARRIER_REJECT_IMPORT(state, data) {
      state.carrierRejectImportObj = data;
    },
    SUBMIT_APPROVAL(state, data) {
      state.submitApprovalObj = data;
    },
    WAREHOUSE_RECEIPT_UPLOAD(state, data) {
      state.warehouseReceiptUploadObj = data;
    },
    URGENT_REJECT_REPORT(state, data) {
      state.rejectReportObj = data;
    },
    DOWN_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    TO_BE_RECEIVED_EXPORT_DATA(state, data) {
      state.toBeReceivedExportObj = data;
    },
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async detailInfo({ commit }, obj) {
      let resp = await detailInfo(obj);
      commit('DETAIL_INFO', resp);
    },
    async deleteBatch({ commit }, obj) {
      let resp = await deleteBatch(obj);
      commit('DELETE_BATCH', resp);
    },
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async toBeReceivedExportData({ commit }, obj) {
      let resp = await toBeReceivedExportData(obj);
      commit('TO_BE_RECEIVED_EXPORT_DATA', resp);
    },
    async carrierRejectImport({ commit }, obj) {
      let resp = await carrierRejectImport(obj);
      commit('CARRIER_REJECT_IMPORT', resp);
    },
    async submitApproval({ commit }, obj) {
      let resp = await submitApproval(obj);
      commit('SUBMIT_APPROVAL', resp);
    },
    async warehouseReceiptUpload({ commit }, obj) {
      let resp = await warehouseReceiptUpload(obj);
      commit('WAREHOUSE_RECEIPT_UPLOAD', resp);
    },
    async urgentRejectReport({ commit }, obj) {
      let resp = await urgentRejectReport(obj);
      commit('URGENT_REJECT_REPORT', resp);
    },
    async downLoadTemplate({ commit }, obj) {
      let resp = await downLoadTemplate(obj);
      commit('DOWN_TEMPLATE', resp);
    },
    /**
     * 拒收原因下拉框
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async rejectReasonList({ commit }, obj) {
      let resp = await getRejectReasonList(obj);
      commit('REJECT_REASON_LIST', resp);
    },
    /**
     * 单据状态
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async rejectStatusList({ commit }, obj) {
      let resp = await getRejectStatusList(obj);
      commit('REJECT_STATUS_LIST', resp);
    },
  }
}
export default rejectInfo



// WEBPACK FOOTER //
// ./src/page/reject/rejectInfo/store/rejectInfo.store.js